import { useState, useEffect } from 'react'
import styles from './index.module.scss'

interface MultiSwitchProps {
  options: string[]
  value?: string
  onChange: (index: string) => void
  disabled ?: boolean
}

export function MultiSwitch({
  options = [],
  value = "",
  onChange,
  disabled
}: MultiSwitchProps) {
  const [activeItem, setActiveItem] = useState<string>(value)

  useEffect(() => {
    setActiveItem(value)
  }, [value])

  return (
    <div className={`${styles.multiSwitchRoot} ${disabled ? styles.disabled : ''}`}>
      {options.map((item: string) => (
        <div
          key={item}
          className={`${styles.item} ${
            activeItem === item ? styles.active : ''
          } ${disabled ? styles.disabledItem : ''}`}
          onClick={() => {
            if (!disabled) {
              setActiveItem(item)
              onChange(item)
            }
          }}
        >
          {item}
        </div>
      ))}
    </div>
  )  
}
